<template>
  <div class='myMenuArea'>
    <ul v-if='myMenus && myMenus.length > 0' class='goodsUl myMenu'>
      <li class='li'>
        <p class='goodsTit'>
          <strong>{{$t('MyPage.total')}}</strong>
          <span><em class='point'>{{myMenus.length}}</em><em>{{$t('MyPage.count')}}</em></span>
        </p>
        <ul class='goodsList'>
          <li v-for='(menu, index) in myMenus' :key='menu.code'>
            <MenuItem
              :menu='menu'
              :index='index'
              :ableDelMenu='true'
              :disableMenuDetail='false'
              @onClickDelBtn='onClickDelBtn'/>
          </li>
        </ul>
      </li>
    </ul>
    <!-- 관심상품가 없는 경우-->
    <div v-else class='noData'>
      <!-- 관심상품에 담긴 상품이 없습니다. -->
      <div class='in'><p>{{$t('MyPage.NoOrderItems')}}</p></div>
    </div>
    <!-- 관심상품 삭제 확인 Alert -->
    <DoubleBtnDialog
      v-if='showDoubleBtnDialogFlag'
      :message='MESSAGE_DOUBLE_BUTTON[MSG_DEL_MY_MENU]'
      :onClickConfirmBtn='onClickConfirmBtn'
      :onClickCancelBtn='onClickCancelBtn'/>
  </div>
</template>
<script lang="js">
import { MY_MENU_CONTAINER } from '@/utils/EndPoint'
import { VIEW_MY_MENU, DEL_MY_MENU } from '@/utils/Code'
import { REQ_MY_MENU } from '@/store/_actions/actionTypes'
import { NETWORK_ERROR_MESSAGE, MSG_DEL_MY_MENU, MESSAGE_DOUBLE_BUTTON } from '@/utils/Message'
import { VIEW_MY_MENU_CMD, DEL_MY_MENU_CMD } from '@/utils/Api'
import MenuItem from '@/components/Common/MenuItem.vue'
import DoubleBtnDialog from '@/components/Dialog/DoubleBtnDialog.vue'
export default ({
  name: MY_MENU_CONTAINER,
  components: { MenuItem, DoubleBtnDialog },
  data () {
    return {
      MSG_DEL_MY_MENU,
      MESSAGE_DOUBLE_BUTTON,
      myMenus: undefined,
      showDoubleBtnDialogFlag: false,
      onClickConfirmBtn: undefined,
      onClickCancelBtn: () => { this.showDoubleBtnDialogFlag = false }
    }
  },
  created () {
    const reqMyMenu = {
      cmd: VIEW_MY_MENU_CMD,
      type: VIEW_MY_MENU
    }
    this.requestMyMenu(reqMyMenu, this.methodSetMyMenu)
  },
  methods: {
    onClickDelBtn (menuCode, index) {
      this.onClickConfirmBtn = () => {
        const reqMyMenu = {
          cmd: DEL_MY_MENU_CMD,
          type: DEL_MY_MENU,
          menuCode: menuCode
        }
        this.requestMyMenu(
          reqMyMenu,
          () => {
            this.myMenus.splice(index, 1)
            this.showDoubleBtnDialogFlag = false
          })
      }
      this.showDoubleBtnDialogFlag = true
    },
    methodForCatch () {
      this.toast(this, NETWORK_ERROR_MESSAGE)
    },
    methodSetMyMenu (response) {
      const menus = response.myMenus
      if (menus.length < 1) this.myMenus = undefined
      else {
        menus.sort((a, b) => a.ordering - b.ordering)
        this.myMenus = menus
      }
    },
    // request my menu view
    requestMyMenu (requestData, methodThen) {
      this.$store.dispatch(REQ_MY_MENU, requestData)
        .then(methodThen).catch(() => this.methodForCatch())
    }
  }
})
</script>
